import { render, staticRenderFns } from "./Cobranzas.vue?vue&type=template&id=33bd4f60&scoped=true"
import script from "./Cobranzas.vue?vue&type=script&lang=js"
export * from "./Cobranzas.vue?vue&type=script&lang=js"
import style0 from "./Cobranzas.vue?vue&type=style&index=0&id=33bd4f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd4f60",
  null
  
)

export default component.exports